export const EventType = {
  conversion: 'conversion',
  purchase: 'purchase'
}
